<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" sm="3" md="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <ca-form-global :mode="mode" :id="id"  :readonly="!isEditable"></ca-form-global>
      </b-container>
    </template>
  </page-outline>
</template>
<script>

import backButton from "@/components/common/backButton.vue"
import CAFormGlobal from "@/pages/security/CAFormGlobal.vue"
import PageOutline from '@/components/common/PageOutline.vue'

export default {
  name: 'CAForm',
  components: {
    'back-button': backButton,
    'ca-form-global':CAFormGlobal,
    'page-outline': PageOutline,

  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    }
  },
  data: () => {
    return {
      formType: 'add',
      pageTitle: '',
      returnUrl: '/security/-1'
    }
  },
  created () {
    this.formType = this.mode
    this.pageTitle = this.$i18n.t('common.security.' + this.mode + '_ca')
  },
  methods: {
  }
}

</script>
